export default __webpack_public_path__ + "static/media/auth-image2.c8d9adf6.png";